define('appkit/radio.mixin',[
  'underscore'
], function(
  _
) {
  var RadioMixin = {

    _initRadio: function(channel, events, replies) {
      var self = this;

      function getFn(fn) {
        if (_.isFunction(fn)) {
          return fn;
        } else if (_.isFunction(self[fn])) {
          return self[fn];
        }
        throw new Error('The function "' + fn + '" does not exist.');
      };
      // regiser all the events
      _.each(events, function(fn, name) {
        channel.on(name, getFn(fn), this);
      }, this);
      // register all the replies
      _.each(replies, function(fn, name) {
        channel.reply(name, getFn(fn), this);
      }, this);
    }

  };

  return RadioMixin;
})
;
